
export const Careers = () => {
    return (
        <div>Careers Page</div>
    )
}